export default $axios => ({
  // api/messageLists/mySubscriptions/{partnerUserId}/{voucher}
  getMessageLists(params = {}) {
    return $axios.get(`/messageLists`, { params });
  },

  getMessageListSubscriptions(partnerUser, offerId, params = {}) {
    return $axios.get(`/api/partnerUser/${partnerUser}/messageLists`, {
      params
    });
  },

  updateSubscriptions(payload, partnerUser, partnerId, params = {}) {
    return $axios.put(
      `/api/partnerUser/${partnerUser}/messageLists/${payload.id}`,
      payload,
      { params }
    );
  }
});
